// Import głównego pliku stylów
import '../css/style.scss';

// Import AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

class App {
    syncPartnerCardTitleHeights() {
        const titles = Array.from(document.querySelectorAll('.partner-card__title'));

        if (!titles.length) {
            return;
        }

        const setHeights = () => {
            let maxHeight = 0;

            titles.forEach(title => {
                title.style.height = 'auto';
                maxHeight = Math.max(maxHeight, title.offsetHeight);
            });

            titles.forEach(title => {
                title.style.height = `${maxHeight}px`;
            });
        };

        setHeights();
        window.addEventListener('resize', setHeights);

        if (document.fonts && typeof document.fonts.ready?.then === 'function') {
            document.fonts.ready.then(setHeights);
        }

        window.addEventListener('load', setHeights, { once: true });
    }

    syncMainOffsetWithHeader() {
        const headerElement = document.querySelector('.js-headroom');

        if (!headerElement) {
            document.documentElement.style.removeProperty('--header-offset');
            return;
        }

        const updateHeaderOffset = () => {
            const styles = window.getComputedStyle(headerElement);
            const marginTop = parseFloat(styles.marginTop) || 0;
            const marginBottom = parseFloat(styles.marginBottom) || 0;
            const headerOffset = headerElement.offsetHeight + marginTop + marginBottom;

            document.documentElement.style.setProperty('--header-offset', `${headerOffset}px`);
        };

        updateHeaderOffset();
        window.addEventListener('resize', updateHeaderOffset);

        if (typeof window.ResizeObserver === 'function') {
            const resizeObserver = new ResizeObserver(updateHeaderOffset);
            resizeObserver.observe(headerElement);
        }
    }

    /**
     * Animations On Scroll (AOS)
     */
    initAos() {
        AOS.init({
            duration: 800, // Czas trwania animacji w ms
            easing: 'ease-out-cubic', // Typ easingu
            once: true, // Animacja tylko raz
            offset: 100, // Offset od góry w px
            delay: 0, // Opóźnienie w ms
            anchorPlacement: 'top-bottom', // Punkt zakotwiczenia
            disable: function() {
                // Wyłącz na urządzeniach mobilnych jeśli chcesz
                return window.innerWidth < 768;
            }
        });
        
        console.log('AOS zainicjalizowane');
    }
    
    /**
     * Init headroom.js
     */
    initHeadroom() {
        const headerElement = document.querySelector('.js-headroom');
        if (headerElement && typeof window.Headroom === 'function') {
            var headroom = new Headroom(headerElement);
            headroom.init();
        } else {
            if (!headerElement) {
                console.warn('Element .js-headroom nie został znaleziony');
            }
            if (typeof window.Headroom === 'undefined') {
                console.warn('Headroom library nie jest dostępna');
            }
        }
    }
    
    /**
     * Init viewer.js
     */
    initViewer() {
        const lightBoxes = document.querySelectorAll('.viewer-js');
        if (lightBoxes.length > 0 && typeof window.Viewer === 'function') {
            lightBoxes.forEach(lightBox => {
                const viewer = new Viewer(lightBox, {
                    title: false,
                });
            });
        } else {
            if (lightBoxes.length === 0) {
                console.log('Brak elementów .viewer-js na stronie');
            }
            if (typeof window.Viewer === 'undefined') {
                console.warn('Viewer library nie jest dostępna');
            }
        }
    }
    
    /**
     * Class toggler
     */
    activeClassToggler() {
        const togglers = document.querySelectorAll('.-js-toggler');
        if (togglers) {
            togglers.forEach(toggler => {
                toggler.addEventListener('click', () => {
                    toggler.classList.toggle('active');
                });
            });
        }
    }

    initRecruitmentSteps() {
        const components = document.querySelectorAll('.js-recruitment-steps');

        if (!components.length) {
            return;
        }

        components.forEach(component => {
            const tabs = Array.from(component.querySelectorAll('.recruitment-step-card'));
            const currentLabel = component.querySelector('.js-recruitment-steps-current');
            const prevArrow = component.querySelector('[data-direction="prev"]');
            const nextArrow = component.querySelector('[data-direction="next"]');
            const mobilePanel = component.querySelector('.recruitment-steps__mobile-panel');
            const mobilePanelTitle = component.querySelector('.recruitment-steps__mobile-panel-title');
            const mobilePanelDesc = component.querySelector('.recruitment-steps__mobile-panel-desc');

            if (!tabs.length) {
                return;
            }

            let activeIndex = tabs.findIndex(tab => tab.classList.contains('is-active'));

            if (activeIndex < 0) {
                activeIndex = 0;
            }

            let autoplayTimer = null;

            const setActiveStep = nextIndex => {
                tabs.forEach((tab, index) => {
                    const isActive = index === nextIndex;
                    const panel = tab.querySelector('.recruitment-step-card__desc');

                    tab.classList.toggle('is-active', isActive);
                    tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
                    tab.setAttribute('tabindex', isActive ? '0' : '-1');

                    if (panel) {
                        panel.hidden = !isActive;
                    }
                });

                activeIndex = nextIndex;

                if (mobilePanel && mobilePanelTitle && mobilePanelDesc) {
                    const activeTab = tabs[activeIndex];
                    const title = activeTab.querySelector('.recruitment-step-card__title');
                    const panel = activeTab.querySelector('.recruitment-step-card__desc');
                    const hasContent = Boolean(title || panel);

                    mobilePanel.hidden = !hasContent;
                    mobilePanelTitle.innerHTML = title ? title.innerHTML : '';
                    mobilePanelDesc.innerHTML = panel ? panel.innerHTML : '';
                }

                if (currentLabel) {
                    currentLabel.textContent = String(activeIndex + 1);
                }

                if (prevArrow instanceof HTMLButtonElement) {
                    prevArrow.disabled = activeIndex === 0;
                }

                if (nextArrow instanceof HTMLButtonElement) {
                    nextArrow.disabled = activeIndex === tabs.length - 1;
                }
            };

            const startAutoplay = () => {
                if (tabs.length < 2) {
                    return;
                }

                window.clearInterval(autoplayTimer);
                autoplayTimer = window.setInterval(() => {
                    const nextIndex = (activeIndex + 1) % tabs.length;
                    setActiveStep(nextIndex);
                }, 5000);
            };

            component.addEventListener('click', event => {
                const arrow = event.target.closest('[data-direction]');
                const tab = event.target.closest('.recruitment-step-card');

                if (arrow) {
                    if (arrow instanceof HTMLButtonElement && arrow.disabled) {
                        return;
                    }

                    const direction = arrow.getAttribute('data-direction');
                    const nextIndex = direction === 'prev'
                        ? Math.max(activeIndex - 1, 0)
                        : Math.min(activeIndex + 1, tabs.length - 1);

                    setActiveStep(nextIndex);
                    startAutoplay();
                    tabs[nextIndex].focus();
                    return;
                }

                if (tab) {
                    const nextIndex = tabs.indexOf(tab);

                    if (nextIndex !== -1) {
                        setActiveStep(nextIndex);
                        startAutoplay();
                    }
                }
            });

            component.addEventListener('keydown', event => {
                const activeTab = event.target.closest('.recruitment-step-card');

                if (!activeTab) {
                    return;
                }

                let nextIndex = activeIndex;

                if (event.key === 'ArrowLeft') {
                    nextIndex = Math.max(activeIndex - 1, 0);
                }

                if (event.key === 'ArrowRight') {
                    nextIndex = Math.min(activeIndex + 1, tabs.length - 1);
                }

                if (nextIndex !== activeIndex) {
                    event.preventDefault();
                    setActiveStep(nextIndex);
                    startAutoplay();
                    tabs[nextIndex].focus();
                }
            });

            setActiveStep(activeIndex);
            startAutoplay();
        });
    }

    /**
     * Execute on page ready
     */
    pageReady() {
        document.body.classList.add('loaded');
        document.body.classList.remove("preload");
    }
    
    reinit() {
        this.initAos();
    }
    
    init() {
        this.syncPartnerCardTitleHeights();
        this.syncMainOffsetWithHeader();
        this.initAos();
        this.initHeadroom();
        this.initViewer();
        this.activeClassToggler();
        this.initRecruitmentSteps();
        this.pageReady();
    }
}

// Inicjalizuj od razu gdy DOM jest gotowy
document.addEventListener('DOMContentLoaded', function() {
    const app = new App();
    app.init();
});

// Automatyczny import wszystkich plików JS (oprócz _app.js)
function requireAll(r) {
    r.keys().forEach(r);
}

// Import wszystkich plików JS z aktualnego folderu (oprócz lib/ i _app.js)
requireAll(require.context('./', false, /^(?!.*\/_app\.js$).*\.js$/));
 